export const refreshMedia = async (mapStore) => {
  const config = mapStore?.config;

  if (!config?.api || !config?.adsignId) {
    return false;
  }

  const response = await fetch(`${config.api}/media/filter`, {
    method: "POST",
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": config.xApiToken ?? "",
    },
    body: JSON.stringify({
      siteId: config.adsignId,
      categoryId: "all",
      type: "published",
      isUnique: false,
    }),
  });

  if (!response.ok) {
    throw new Error(`Media API returned ${response.status}`);
  }

  const payload = await response.json();

  if (payload.error || !Array.isArray(payload.data)) {
    throw new Error(payload.message || "Media API returned invalid data");
  }

  mapStore.medias = payload.data;
  return true;
};
